import { render } from "./AppointmentsHome.vue?vue&type=template&id=712fc89a&ts=true"
import script from "./AppointmentsHome.vue?vue&type=script&lang=ts"
export * from "./AppointmentsHome.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__